var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconErrorCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.661 2.625C8.29975 2.625 3.125 7.79975 3.125 14.161C3.125 20.5222 8.29975 25.6961 14.661 25.6961C21.0222 25.6961 26.1961 20.5222 26.1961 14.161C26.1961 7.79975 21.0214 2.625 14.661 2.625ZM14.661 23.6259C9.4425 23.6259 5.197 19.3795 5.197 14.161C5.197 8.9425 9.4425 4.697 14.661 4.697C19.8804 4.697 24.1259 8.9425 24.1259 14.161C24.1259 19.3795 19.8795 23.6259 14.661 23.6259Z",
    fill: "#F7C412"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4327 8.75L13.625 8.75L13.625 16.3914L15.4327 16.3914L15.4327 8.75Z",
    fill: "#F7C412"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4327 18.0836L13.625 18.0836L13.625 19.8905L15.4327 19.8905L15.4327 18.0836Z",
    fill: "#F7C412"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconErrorCircle);
export default __webpack_public_path__ + "static/media/icon-error-circle.a29ce4bdfb3b966151f3003a7eaef1c7.svg";
export { ForwardRef as ReactComponent };